import React from 'react';
import clsx from 'clsx';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ILinkComponentProps {
	text?: string;
	link: string;
	additionalClass?: string;
	isUnderLine?: boolean;
	children?: JSX.Element
	inPage?: boolean;
	withIcon?: boolean;
}

export const LinkComponent = (props: ILinkComponentProps):JSX.Element => {
	const { text, link, additionalClass, isUnderLine, children, inPage, withIcon } = props;
	return (
		// Don't change to div!
		<span className="fc-link">
			<a
				href={link}
				target={inPage ? '_self' : '_blank'}
				rel="noreferrer"
				className={clsx(
					'cursor-pointer text-danger',
					isUnderLine && 'text-decoration-underline',
					additionalClass
				)}
			>
				{text ? text : children}
			</a>
			{
				withIcon && (
					<FontAwesomeIcon icon={faArrowUpRightFromSquare} width={12} className="ms-2 text-danger"/>
				)
			}
		</span>
	);
};
